import { Shape }                 from '@tokamap/core';
import { LinkedContentResolver } from '@tokamap/core';
import { applyLinkedContent }    from '@tokamap/core';

export const PLACE_LABEL_SOURCE = 'place.label';
export const PLACE_IMAGE_SOURCE = 'place.image';

export function placeLabel(shape: Shape): string | undefined {
	const label = (shape.entity as any)?.entity?.label;

	return typeof label === 'string' ? label : undefined;
}

export function placeImage(shape: Shape): string | undefined {
	const image = (shape.entity as any)?.entity?.image;

	return typeof image === 'string' ? image : undefined;
}

export const resolvePlaceLinkedContent: LinkedContentResolver = (shape, source) => {
	if (source === PLACE_LABEL_SOURCE) return placeLabel(shape);
	if (source === PLACE_IMAGE_SOURCE) return placeImage(shape);

	return undefined;
};

export function displayedShape(shape: Shape): Shape {
	return applyLinkedContent(shape, resolvePlaceLinkedContent);
}
